export default __webpack_public_path__ + "static/media/successful-call.fb816137.svg";